module.exports = __webpack_public_path__ + "e4967463ea44b5fadb4349bcdea1e13a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/radiant@2x.png
// module id = 314
// module chunks = 0